import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import Login from "../newView/Login";
import {Content} from "antd/es/layout/layout";
import AppHeader from "./jutge/components/AppHeader";
import AppBreadcrumb from "./jutge/components/AppBreadcrumb";
import {FloatButton, Layout} from "antd";
import AppFooter from "./components/AppFooter";
import AppJutgeRoutes from "./routes/AppJutgeRoutes";

import "../styles/PulseButton.css";
import {HiOutlineLightBulb} from "react-icons/hi";
import ChatTableModal from "./jutge/components/ChatTableModal";

const Jutge = () => {
    const {isLoggedIn} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [dades, setDades] = useState<string>();
    const [modal, setModal] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        checkDades(id);
    }, [id]);

    async function checkDades(id: any) {
        setLoading(true);
    }

    function getChat() {
        setModal(true);
    }

    function onClose() {
        setModal(false);
    }

    if (isLoggedIn) {
        return (
            <Layout style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                <AppHeader/>
                <Content style={{padding: '0 48px', flex: '1 0 auto'}}>
                    <AppBreadcrumb/>
                    <Layout style={{padding: '24px 0', background: '#fff', borderRadius: '8px'}}>
                        <AppJutgeRoutes/>
                    </Layout>

                    {/* Botón con animación */}
                    {false && <div className="pulse-wrapper">
                        <FloatButton
                            shape="circle"
                            type={"primary"}
                            onClick={() => getChat()}
                            icon={<HiOutlineLightBulb/>}
                            style={{
                                insetInlineStart: 1200,
                                backgroundColor: "red", // Color de fondo
                                color: "red",              // Color del icono
                                border: "none",
                            }}
                        />
                    </div>}

                    {modal && <ChatTableModal visible={modal} onClose={() => onClose()}/>}
                </Content>
                <AppFooter/>
            </Layout>
        );
    } else {
        return <Login isJutge={true} />;
    }
};

export default Jutge;
